const Browse_category_data = [
	{
		id: '0Virtual Worlds',
		image: '/images/categories/category_4.png',
		title: 'Virtual Worlds',
		href: '#',
		bgColor: 'rgb(70 199 227)',
	},
	{
		id: '1Sport',
		image: '/images/categories/category_5.png',
		title: 'Sport',
		href: '#',
		bgColor: 'rgb(115 126 242)',
	},
	{
		id: '2Photography',
		image: '/images/categories/category_6.png',
		title: 'Photography',
		href: '#',
		bgColor: 'rgb(66 138 248)',
	},
	{
		id: '3Music',
		image: '/images/categories/category_7.png',
		title: 'Music',
		href: '#',
		bgColor: 'rgb(243 91 199)',
	},
	{
		id: '4Art',
		image: '/images/categories/category_1.png',
		title: 'Art',
		href: '#',
		bgColor: 'rgb(16 185 129)',
	},
	{
		id: '5Collectibles',
		image: '/images/categories/category_2.png',
		title: 'Collectibles',
		href: '#',
		bgColor: 'rgb(254 178 64)',
	},
	{
		id: '6Domain Names',
		image: '/images/categories/category_3.png',
		title: 'Domain Names',
		href: '#',
		bgColor: 'rgb(131 88 255)',
	},
	{
		id: '7Virtual Worlds',
		image: '/images/categories/category_4.png',
		title: 'Virtual Worlds',
		href: '#',
		bgColor: 'rgb(70 199 227)',
	},
	{
		id: '8Sport',
		image: '/images/categories/category_5.png',
		title: 'Sport',
		href: '#',
		bgColor: '#737EF2',
	},
	{
		id: '9Photography',
		image: '/images/categories/category_6.png',
		title: 'Photography',
		href: '#',
		bgColor: 'rgb(66 138 248)',
	},
	{
		id: '10Music',
		image: '/images/categories/category_7.png',
		title: 'Music',
		href: '#',
		bgColor: '#F35BC7',
	},
	{
		id: '11Art',
		image: '/images/categories/category_1.png',
		title: 'Art',
		href: '#',
		bgColor: 'rgb(16 185 129)',
	},
	{
		id: '12Virtual Worlds',
		image: '/images/categories/category_4.png',
		title: 'Virtual Worlds',
		href: '#',
		bgColor: '#46C7E3',
	},
	{
		id: '13Domain Names',
		image: '/images/categories/category_3.png',
		title: 'Domain Names',
		href: '#',
		bgColor: 'rgb(131 88 255)',
	},

	{
		id: '14Collectibles',
		image: '/images/categories/category_2.png',
		title: 'Collectibles',
		href: '#',
		bgColor: 'rgb(254 178 64)',
	},
];

export default Browse_category_data;
